import { useContext, useEffect, useState } from "react";
import { auth, firestore } from "./firebase";
import Sidebar from "./Sidebar";
import Field from "./Field";
import { UserContext } from "./providers/UserProvider";
import { reauthenticateWithCredential, updatePassword ,EmailAuthProvider, updateEmail } from "firebase/auth";
import { toast } from "react-toastify";


export default function AccountSettings() {

    const { user } = useContext(UserContext);
    const [userEmail, setUserEmail] = useState(user.email);
    const [email, setEmail] = useState(user.email);
    const [emailPassw, setEmailPassw] = useState("");
    const [currPassw, setCurrPassw] = useState("");
    const [password, setPassword] = useState("");
    const [passwordAgain, setPasswordAgain] = useState("");
    const [newPasswBoxVisible,setNewPasswBoxVisible] = useState(false)

    function checkPassw(){
      if(currPassw.length !== 0){
        const credential = EmailAuthProvider.credential(
          auth.currentUser.email,
          currPassw
        );
    
        reauthenticateWithCredential(auth.currentUser, credential)
          .then(() => {
            setNewPasswBoxVisible(true);
          })
          .catch(e => {
            console.log(e); // Log the full error object for debugging
            switch (e.code) {
              case "auth/wrong-password":
                toast.error("Falsches Passwort");
                break;
              case "auth/too-many-requests":
                toast.error("Zu viele Fehlversuche, versuche es später erneut");
                break;
              default:
                toast.error("Ein unbekannter Fehler ist aufgetreten");
                break;
            }
          });
      } else {
        toast.info("Bitte gib ein Passwort an!", {theme: "dark"});
      }
    }

    async function saveEmail() {
        try {
            await reauthenticateWithCredential(user, EmailAuthProvider.credential(
                auth.currentUser.email,
                emailPassw,
            ));
            await updateEmail(user, email);
            toast.success('Email erfolgreich gespeichert');
            setUserEmail(email);
        } catch(e) {
            switch(e.code) {
                case 'auth/invalid-email': alert('Die eingegebene E-Mail-Adresse ist nicht gültig. Bitte mit einer richtigen E-Mail-Adresse erneut versuchen.'); break;
                case 'auth/wrong-password': alert('Falsches Passwort, bitte erneut versuchen.'); break;
                case 'auth/missing-password': alert('Bitte gib dein Passwort ein.'); break;
                default: alert(`Das hat leider nicht geklappt. Bitte probiere es später erneut. (${e})`); break;
            }
        }
    }

    async function createNewPassw() {
        const credential = EmailAuthProvider.credential(
            auth.currentUser.email,
            currPassw
        );
        currPassw.length > 0 ? 
            reauthenticateWithCredential(auth.currentUser,credential).then(() => {
                updatePassword(auth.currentUser,password).then(() => {
                    setNewPasswBoxVisible(!newPasswBoxVisible);
                    setCurrPassw('');
                    setPassword('');
                    setPasswordAgain('');
                    toast.success("Dein Passwort wurde geändert");
                });
            })
            .catch((e) => {
                toast.error("Es ist ein Fehler aufgetreten, bitte wiederhole den Vorgang.")
                console.error(e);
            }) 
        :                  
        currPassw.length === 0
        ?
        toast.error("Bitte geben gib dein aktuelles Passwort ein") 
        : 
        toast.error("Passwort entspricht nicht den Richtlinien")
    }

    return <div className="h-full flex w-auto">
        <Sidebar defaultOpen={false} />
        <div className="flex-grow overflow-auto">
            <div className="h-screen flex flex-col overflow-hidden">
                <div className="bg-gray-600 flex items-center text-white gap-2 p-3 justify-between">
                    <div className="text-l font-semibold">E-Mail-Einstellungen</div>
                </div>
                <div className="p-3 overflow-y-scroll">
                    <b>E-Mail-Adresse</b>
                    <Field name="E-Mail" value={email} onChange={e => setEmail(e)} />
                    <div style={{visibility: email.toLowerCase() === userEmail.toLowerCase() ? 'hidden' : 'visible'}}>
                        <div>Bitte gib aus Sicherheitsgründen dein Passwort erneut ein, um deine E-Mail-Adresse zu ändern:</div>
                        <Field name="Passwort" type="password" value={emailPassw} onChange={e => setEmailPassw(e)} onLineBreak={saveEmail} />
                        <button className="bg-blue-500 text-white px-4 py-2 rounded mt-2" onClick={saveEmail}>Speichern</button>
                    </div>

                    <b>Passwort ändern</b>
                    <div>Bitte gib dein akutelles Passwort ein, um ein neues Passwort zu erstellen.</div>
                    <Field name="Aktuelles Passwort" type="password" value={currPassw} onChange={e => setCurrPassw(e)} onLineBreak={checkPassw} />
                    <button className="bg-blue-500 text-white px-4 py-2 rounded mt-2" onClick={checkPassw}>Passwort überprüfen</button>
                    <div style={{display: newPasswBoxVisible ? 'block' : 'none'}}>
                        Bitte gib nun dein neues Passwort ein und bestätige dies.
                        <Field name="Neues Passwort" type="password" value={password} onChange={e => setPassword(e)} onLineBreak={createNewPassw} />
                        <Field name="Neues Passwort wiederholen" type="password" value={passwordAgain} onChange={e => setPasswordAgain(e)} onLineBreak={createNewPassw} />
                        <button className="bg-blue-500 text-white px-4 py-2 rounded mt-2" onClick={createNewPassw}>Neues Passwort erstellen</button>
                    </div>
                </div>
            </div>
        </div>
    </div>;
}